"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=deprecation.js.map